// AUTO-GENERATED at build time by scripts/genBuildInfo.js. Do not edit by hand.
export const BUILD_DATE = "2026-11-05";
